export default __webpack_public_path__ + "static/media/manti.33d8cd30.png";